<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('printarea')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
                <v-btn color="success" class="button-shadow" to="/employee/list">
                  <v-icon class="mr-2">mdi-check</v-icon>
                  Done
                </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
        <v-col v-if="format==1" cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="12" sm="12">
            <v-card class="ma-1">
              <v-card-text id="printarea" class="printBody">
                <div class="format1">
                <div class="format1 whole-block" v-bind:style="cardimage">
                      <div class="format1 inner-block">
                        <div class="format1 photo-block">
                          <img class="format1 photoimage" v-bind:src="initvalue.employeeimage">
                        </div>
                        <div class="format1 name-block">
                          <span class="username">{{ initvalue.employeename }}</span>
                          <span class="department">{{ initvalue.employeetitle }}</span>
                        </div>
                        <div class="qr-block">
                          <img :src="cardurl" style="border: 3px solid white; width: 68px; height: 68px">
                        </div>
                      </div>
                </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
        <v-col v-else-if="format==2" cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="12" sm="12">
            <v-card class="ma-1">
              <v-card-text id="printarea" class="printBody">
                <div class="format2">
                <div class="format2 whole-block" v-bind:style="cardimage">
                      <div class="format2 inner-block">
                        <div class="format2 photo-block">
                          <img class="format2 photoimage" v-bind:src="initvalue.employeeimage">
                        </div>
                        <div class="format2 name-block">
                          <span class="format2 username">{{ initvalue.employeename }}</span>
                          <span class="format2 department">{{ initvalue.departmentid!=null ? departments.find(dept=>dept._id==initvalue.departmentid)['departmentname'] + " Dept" : '' }}</span>
                          <span class="format2 employeetitle">{{ initvalue.employeetitle }}</span>
                        </div>
                        <div class="qr-block">
                          <img :src="cardurl" style="border: 3px solid white; width: 70px; height: 70px">
                        </div>
                      </div>
                </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-else-if="format==3" cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="12" sm="12">
            <v-card class="ma-1">
              <v-card-text id="printarea" class="printBody">
                <div class="format3">
                <div class="format3 whole-block" v-bind:style="cardimage">
                      <div class="format3 inner-block">
                        <div class="format3 photo-block">
                          <img class="format3 photoimage" v-bind:src="initvalue.employeeimage">
                        </div>
                        <div class="format3 name-block">
                          <span class="format3 username">{{ initvalue.employeename }}</span>
                          <span class="format3 department">{{ initvalue.departmentid!=null ? departments.find(dept=>dept._id==initvalue.departmentid)['departmentname'] + " Dept" : '' }}</span>
                          <span class="format3 employeetitle">{{ initvalue.employeetitle }}</span>
                        </div>
                        <div class="qr-block">
                          <img :src="cardurl" style="border: 3px solid white; width: 68px; height: 68px">
                        </div>
                      </div>
                </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            cardimage: null,
            cardqr: null,
            cardurl: null,
            format: '',
          };
        },
        methods: {
          ...mapActions('Department', ['getDepartmentsRequest']),
          ...mapActions('Qrcode', ['createQrcodeRequest']),
          ...mapActions('Region', ['getRegionsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');


            var css3 = `
                      <style>
                        @page {
                            margin: 0px !important;
                            padding: 0px !important;
                        }
                        @media print {
                          .body{
                            margin: 0px !important;
                            padding: 0px !important;
                            -webkit-print-color-adjust: exact !important;
                          }
                          body.whole-block {
                            margin-top: 0px !important;
                            margin-left: 0px !important;
                            margin-right: 0px !important;
                            margin-bottom: 0px !important;
                            padding: 0px !important;
                            width: 5.5cm;
                            height: 8.71m;
                            background-size: auto 100%;
                            -webkit-print-color-adjust: exact !important;
                          }
                          @page {
                            margin: 0px !important;
                            padding: 0px !important;
                          }
                        }
                        .whole-block {
                          margin-top: 0px !important;
                          margin-left: 0px !important;
                          margin-right: 0px !important;
                          margin-bottom: 0px !important;
                          padding: 0px;
                          width: 5.5cm;
                          height: 8.71cm;
                          background-size: 100%;
                          background-repeat: no-repeat;
                          -webkit-print-color-adjust: exact;
                        }
                        .photo-block img {
                          height: 2.4cm;
                          width: 2.4cm;
                        }
                        .photoimage{
                          border: 4px solid #009d4f !important; 
                          border-radius: 4px;
                        }
                        .name-block{
                          margin-top: 5px;
                          height: 1.50cm;
                          line-height: 100%;
                        }
                        .username {
                          display: block;
                          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                          font-size: 16px;
                          font-weight: bolder;
                          text-transform: uppercase;
                        }
                        .employeetitle {
                          margin-top: 0px;
                          margin-bottom: 0px;
                          display: block;
                          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                          font-size: 11px;
                        }
                        .department {
                          margin-top: 0px;
                          margin-bottom: 0px;
                          display: block;
                          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                          font-size: 11px;
                          font-weight: bold;
                        }
                        .inner-block {
                          padding-top: 88px;
                          border-radius: 10px;
                          text-align: center;
                        }
                        .card-block {
                          height: 8.71cm;
                          width: 5.4cm;
                          margin: 0 auto;
                          position: relative;
                        }
                        .qr-block {
                          margin: 0px;
                          padding: 0px;
                        }
                      </style>
                    `;

            var css2 = `
                      <style>
                        @page {
                            margin: 0px !important;
                            padding: 0px !important;
                        }
                        @media print {
                          .body{
                            margin: 0px !important;
                            padding: 0px !important;
                            -webkit-print-color-adjust: exact !important;
                          }
                          body.whole-block {
                            margin-top: 0px !important;
                            margin-left: 0px !important;
                            margin-right: 0px !important;
                            margin-bottom: 0px !important;
                            padding: 0px !important;
                            width: 5.5cm;
                            height: 8.71m;
                            background-size: auto 100%;
                            -webkit-print-color-adjust: exact !important;
                          }
                          @page {
                            margin: 0px !important;
                            padding: 0px !important;
                          }
                        }
                        .whole-block {
                          margin-top: 0px !important;
                          margin-left: 0px !important;
                          margin-right: 0px !important;
                          margin-bottom: 0px !important;
                          padding: 0px;
                          width: 5.5cm;
                          height: 8.71cm;
                          background-size: 100%;
                          background-repeat: no-repeat;
                          -webkit-print-color-adjust: exact;
                        }
                        .photo-block img {
                          height: 2.4cm;
                          width: 2.4cm;
                        }
                        .photoimage{
                          border: 4px solid #009d4f !important; 
                          border-radius: 4px;
                        }
                        .name-block{
                          margin-top: 5px;
                          height: 1.75cm;
                          line-height: 100%;
                        }
                        .username {
                          display: block;
                          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                          font-size: 16px;
                          font-weight: bolder;
                          text-transform: uppercase;
                        }
                        .employeetitle {
                          margin-top: 0px;
                          margin-bottom: 0px;
                          display: block;
                          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                          font-size: 11px;
                        }
                        .department {
                          margin-top: 0px;
                          margin-bottom: 0px;
                          display: block;
                          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                          font-size: 11px;
                          font-weight: bold;
                        }
                        .inner-block {
                          padding-top: 75px;
                          border-radius: 10px;
                          text-align: center;
                        }
                        .card-block {
                          height: 8.71cm;
                          width: 5.4cm;
                          margin: 0 auto;
                          position: relative;
                        }
                        .qr-block {
                          margin: 0px;
                          padding: 0px;
                        }
                      </style>
                    `;

            var css1 = `
                      <style>
                        @page {
                            margin: 0px !important;
                            padding: 0px !important;
                        }
                        @media print {
                          .body{
                            margin: 0px !important;
                            padding: 0px !important;
                            -webkit-print-color-adjust: exact !important;
                          }
                          body.whole-block {
                            margin-top: 0px !important;
                            margin-left: 0px !important;
                            margin-right: 0px !important;
                            margin-bottom: 0px !important;
                            padding: 0px !important;
                            width: 5.5cm;
                            height: 8.71cm;
                            background-size: auto 100%;
                            -webkit-print-color-adjust: exact !important;
                          }
                          @page {
                            margin: 0px !important;
                            padding: 0px !important;
                          }
                        }
                        .whole-block {
                          margin-top: 0px !important;
                          margin-left: 0px !important;
                          margin-right: 0px !important;
                          margin-bottom: 0px !important;
                          padding: 0px;
                          width: 5.5cm;
                          height: 8.71cm;
                          background-size: 100%;
                          background-repeat: no-repeat;
                          -webkit-print-color-adjust: exact;
                        }
                        .photo-block img {
                          margin-top: 0px;
                          height: 2.5cm;
                          width: 2.5cm;
                        }
                        .photoimage {
                          border: 4px solid #009d4f !important; 
                          border-radius: 4px;
                        }
                        .name-block {
                          margin-top: 10px;
                          height: 1.4cm;
                          line-height: 100%;
                        }
                        .username {
                          display: inline-block;
                          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                          font-size: 16px;
                          font-weight: bolder;
                          text-transform: uppercase;
                        }
                        .department {
                          display: inline-block;
                          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                          font-size: 12px;
                        }
                        .inner-block {
                          padding-top: 75px;
                          border-radius: 10px;
                          text-align: center;
                          vertical-align: text-top;
                        }
                        .card-block {
                          height: 8.71cm;
                          width: 5.4cm;
                          margin: 0 auto;
                          position: relative;
                        }
                        .qr-block {
                          margin: 0px;
                          padding: 0px;
                        }
                      </style>
                    `;


            mywindow.document.write('<html><head>' + this.format==1 ? css1 : this.format==2 ? css2 : this.format==3 ? css3 : css1 + '<title>Print</title>');
            
            mywindow.document.write('</head><body class="body" onclick="window.print();" style="margin: 0; padding: 0">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          }
        },
        computed: {
          ...mapState('Department', ['departments']),
          ...mapState('User', ['users']),
        },
        async created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'EmployeeList' });
          if(this.departments.length==0) await this.getDepartmentsRequest();
          if(this.users.length==0) await this.getUsersRequest();
          let url = "http://www.tradexc.com/#/namecard/" + this.initvalue._id + "";
          this.cardurl = await this.createQrcodeRequest(url);
          console.log('url', this.cardurl);


          if(this.initvalue.companyid=='60a8acb67418a3429476cd42'){
            this.format = 1;
            this.cardimage = 'background-size: cover; background-image: url(' + 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhs_id_card.jpg' +  ');';
            this.cardqr = "https://chart.googleapis.com/chart?cht=qr&chl=http://www.tradexc.com/%23/namecard/" + this.initvalue._id + "/&chs=100x100&cht=qr&choe=UTF-8&chld=L|0";
          }
          else if(this.initvalue.companyid=='62a95796d863cc07ac031227'){
            this.format = 1;
            this.cardimage = 'background-size: cover; background-image: url(' + 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhs_id_card.jpg' +  ');';
            this.cardqr = "https://chart.googleapis.com/chart?cht=qr&chl=http://www.tradexc.com/%23/namecard/" + this.initvalue._id + "/&chs=100x100&cht=qr&choe=UTF-8&chld=L|0";
          }
          else if(this.initvalue.companyid=='60b07f300d820029acae4734'){
            this.format = 2;
            this.cardimage = 'background-size: cover; background-image: url(' + 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alh_id_card.jpg' +  ');';
            this.cardqr = "https://chart.googleapis.com/chart?cht=qr&chl=http://www.tradexc.com/%23/namecard/" + this.initvalue._id + "/&chs=100x100&cht=qr&choe=UTF-8&chld=L|0";
          } 
          else if(this.initvalue.companyid=='62b2ee8e2e2f21f3622920e0'){
            this.format = 3;
            this.cardimage = 'background-size: cover; background-image: url(' + 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/ydbn_id_card.png' +  ');';
            this.cardqr = "https://chart.googleapis.com/chart?cht=qr&chl=http://www.tradexc.com/%23/namecard/" + this.initvalue._id + "/&chs=100x100&cht=qr&choe=UTF-8&chld=L|0";
          }
          else if(this.initvalue.companyid=='62b4331045dc085e6430d3ce'){
            this.format = 3;
            this.cardimage = 'background-size: cover; background-image: url(' + 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/apdc_id_card.jpg' +  ');';
            this.cardqr = "https://chart.googleapis.com/chart?cht=qr&chl=http://www.tradexc.com/%23/namecard/" + this.initvalue._id + "/&chs=100x100&cht=qr&choe=UTF-8&chld=L|0";
          }         
        },
    };
</script>

<style src="./Card.scss" lang="scss" scoped />
